import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { MessageListComponent } from '@app/shared/components/message-list/message-list.component';

@Component({
	selector: 'formly-message-list',
	template: `<shared-message-list [messages]="props.messages" [appearance]="props.appearance" [cardMaxHeight]="props.cardMaxHeight">
	</shared-message-list>`,
	standalone: true,
	imports: [MessageListComponent],
})
export class FormlyMessageListComponent extends FieldType {}
